<template>
  <div class="drawer-wrapper">
    <el-drawer
        :wrapperClosable="true"
        :title="title"
        :visible.sync="CastCrewEdit"
        size="50%"
        direction="rtl"
        :before-close="handleClose">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" size="medium" label-width="100px" class="mt35" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="演职人员名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addFrom.name" placeholder="请输入名称" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20">
              <el-form-item label="演职人员类型" prop="type" :label-width="formLabelWidth">
                <el-radio-group v-model="addFrom.type" @change="handelgroup">
                  <el-radio :label="1">导演</el-radio>
                  <el-radio :label="2">制作人</el-radio>
                  <el-radio :label="3">演员</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" v-if="addFrom.type==3">
              <el-form-item label="演员头像" prop="picture_url" :label-width="formLabelWidth">
                <el-upload class="avatar-uploader" action :http-request="(file) => httpRequest(file)"
                           :show-file-list="false" :on-success="handleSuccess"
                           :before-upload="beforeAvatarUpload">
                  <img v-if="picture_url" :src="picture_url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="border:1px solid #ccc;"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="20" class="mb20" v-if="addFrom.type==3">
              <el-form-item label="演员简介" prop="cast_profile" :label-width="formLabelWidth">
                <el-input v-model="addFrom.cast_profile" type="textarea" placeholder="请输入演员简介"
                          :autosize="{ minRows: 2, maxRows: 10 }" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
import {CastCrewAPI} from "@/api/Works/CastCrew"
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['CastCrewEdit', "editID"],
  components: {},
  data() {
    return {
      formLabelWidth: "160px",
      title: "新增",
      addFrom: {
        name: "",
        type: 1,
        picture_url: "",
        id: "",
        cast_profile: ""
      },
      rules: {
        name: [
          {required: true, message: '请输入演职人员名称', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择演职人员类型', trigger: 'change'}
        ],
        picture_url: [
          {required: true, message: '请上传头像', trigger: 'blur'},
        ],
        cast_profile: [
          {required: true, message: '请输入演员简介', trigger: 'blur'},
        ],
      },
      picture_url: '',
    };
  },
  created() {

  },
  methods: {
    handelgroup(e) {
      if (e == 1 || e == 2) {
        this.picture_url = ""
        this.addFrom.cast_profile = ""
      }
    },
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addFrom = {
        name: "",
        type: "",
        picture_url: "",
        id: "",
        cast_profile: ""
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.addFrom.id == "") {
            let api = CastCrewAPI()
            api.CastCrewAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
              }

            })
          } else {
            let api = CastCrewAPI()
            api.CastCrewAdded(this.addFrom).then(res => {
              if (res.code == 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.$emit('AddOk');
              } else {
                processErrors(res);
              }

            })
          }

        } else {
          return false;
        }
      });

    },

    /**
     * 上传头像
     */
    httpRequest(file) {
      let api = CastCrewAPI()
      let imageUpload = new FormData();
      imageUpload.append("file", file.file);

      api.fileAvatarUpload(imageUpload).then((res) => {
        if (res.code == 0) {
          this.picture_url = res.data.url_full;
          this.addFrom.picture_url = res.data.url;
        } else {
          processErrors(res);
        }
      });
    },

    handleSuccess(res, file) {
      this.addFrom.picture_url = URL.createObjectURL(file.raw);
    },

    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 5;
    },
  },

  mounted() {
    if (this.editID != "") {
      let api = CastCrewAPI()
      api.detailsList(this.editID).then(res => {
        if (res.code == 0) {
          this.title = "编辑"
          this.addFrom = {
            name: res.data.name,
            type: res.data.type,
            picture_url: res.data.picture_url,
            id: res.data.id,
            cast_profile: res.data.cast_profile
          }
          this.picture_url = res.data.picture_url_all
        } else {
          processErrors(res);
        }
      })
    }

  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>